var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "177 0 708 708",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1063v708.66h-1063z",
    fill: "#ec0015",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(11.912 0 0 12.458 -2509.8 -6130.7)",
    d: "m266.186,534.45-10.408-7.432-10.357,7.505 3.852-12.196-10.338-7.531 12.79-.105 3.967-12.159 4.052,12.131 12.79.016-10.285,7.602 3.937,12.169z",
    fill: "#ff0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagVn);
export default __webpack_public_path__ + "static/media/flag_vn.1feaf033a63ca48fb2ae383fb80589cd.svg";
export { ForwardRef as ReactComponent };